import React from 'react';
import { injectIntl } from 'react-intl';

import ReactEcharts from 'components/HTMLElements/ReactECharts';

const Chart = ( { data = {}, intl, chatActive, phoneActive } ) => {
  const pie = {};
  pie.options = {
    tooltip: {
      show: true,
      trigger: 'item',
      formatter: '{b}: {c} ({d}%)'
    },
    legend: {
      show: false,
      orient: 'vertical',
      x: 'right',
    },
    series: [{
      type: 'pie',
      selectedMode: 'single',
      radius: ['40%', '52%'],
      color: [
        '#4267b2',
        '#1DA1F2',
        '#ffc107',
        '#EF5350',
      ],
      label: {
        normal: {
          position: 'outside',
          formatter: '{b}',
          textStyle: {
            fontSize: 12
          }
        }
      },
      labelLine: {
        normal: {
          show: true
        }
      },
      data: [
        { value: data['FACEBOOK'] || 0, name: intl.formatMessage( { id: "facebook" } ) },
        { value: data['TWITTER'] || 0, name: intl.formatMessage( { id: "twitter" } ) },
        { value: data['EMAIL'] || 0, name: intl.formatMessage( { id: "email" } ) },
        { value: data['WALK_IN'] || 0, name: intl.formatMessage( { id: "walkin" } ) },
        phoneActive ? { value: data['PHONE'] || 0, name: intl.formatMessage( { id: "phone" } ) } : {},
        chatActive ? { value: data['CHAT'] || 0, name: intl.formatMessage( { id: "chat" } ) } : {},
      ],
      markPint: {
        symbol: 'diamond',
        data: [{ symbol: 'diamond', }]
      }
    }]
  };

  return (<ReactEcharts style={{ height: '300px' }} option={pie.options}
                        showLoading={false}/>);
};

module.exports = injectIntl( Chart );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/AquisitionChart.js